import Styled from 'styled-components';

const TextBox = Styled.span`
  background-color: #101010;
  color: #fff;
  padding: 12px;
  line-height: 1;
  position: absolute;
  right: calc(100% + 10px);
  top: -30%;
  font-family: Exo BNNVARA, Exo, Verdana, sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 16px;
  white-space: nowrap;
  
`;

export default TextBox;
